import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

// Interface for the label object
interface Label {
    key: string;
    value: string;
}

// Styled components for the button states
const ToggleButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  position: relative;
  z-index: 1;
  padding: 4px;
  border-radius: 99px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  background: ${({ theme }) => theme.playerContentBackground};
  justify-content: inherit;
`;

// Styled component for the toggle button
interface ToggleButtonProps {
    isActive: boolean;
}

const ToggleBtn = styled.button<ToggleButtonProps>`
    flex: 1;
    white-space: pre;
    border: none;
    padding: 7.5px 13px;
//   cursor: pointer;
  outline: none;
  font-size: 13px;
  font-weight: bold;
  background-color: ${({ isActive, theme }) => isActive ? 'var(--Brand-green-1-500, #00D1A8)' : theme.playerContentBackground};
  color: ${({ isActive }) => isActive ? 'black' : 'white'};
  //border: 2px solid ${({ isActive }) => isActive ? '#0AFC7F' : 'black'};
  transition: background-color 0.3s ease;
  border-radius: 20px;
//   min-width:35px;

  & .tab-switch-text{
    color: ${({ isActive, theme }) => isActive ? "#111111" : theme.NumberColor};
    font-feature-settings: 'clig' off, 'liga' off;

    /* DM-Mono/Label/Medium */
    font-family: "DM Mono";
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 12px; /* 100% */
    text-transform: uppercase;
  }
`;

// Props interface for the TripleToggleButton component
interface TripleToggleButtonProps {
    labels: Label[];
    defaultLabelKey: string;
    onChange?: (label: Label) => void;
}

// React component for the triple toggle button
const ToggleButton: React.FC<TripleToggleButtonProps> = ({ labels, defaultLabelKey, onChange }) => {
    const [activeIndex, setActiveIndex] = useState<number>(0);

    useEffect(() => {
        const newIndex = labels.findIndex(label => label.key === defaultLabelKey);
        if (newIndex !== -1 && newIndex !== activeIndex) {
            setActiveIndex(newIndex);
        }
    }, [defaultLabelKey, labels, activeIndex]);

    const handleToggle = (index: number) => {
        setActiveIndex(index);
        onChange && onChange(labels[index]);
    };

    return (
        <ToggleButtonWrapper>

            {labels.map((label, index) => (

                <ToggleBtn
                    key={index}
                    isActive={activeIndex === index}
                    onClick={() => handleToggle(index)}
                >
                    <span className='tab-switch-text'>{label.value}</span>
                </ToggleBtn>

            ))}

        </ToggleButtonWrapper>
    );
};

export default ToggleButton;
